import React, { Component } from "react";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Container, Head, Avatar } from "./styles.js";

import AuthActions from "../../../storeChat/ducks/auth";
import UsersActions from "../../../storeChat/ducks/users";
import MessagesActions from "../../../storeChat/ducks/messages";

import socket from "../../../services/io";

import Loading from "../../../components/LoadingChat";
import AvatarImg from "../../../assets/avatar-anonimo.png";

class Chat extends Component {
  state = {
    content: "",
    messages: [],
    current_date: new Date(),
    typing: false,
    typingTarget: ""
  };

  componentDidMount() {
    // adiciona usuário na room
    socket.emit(
      "add user to chat room",
      `${this.props.chat.id_from}${this.props.chat.id_to}${
        this.props.chat.customer_key
      }`
    );

    socket.on("new message", data => {
      // verifica se estou com o chat aberto para atualizar as mensagens
      if (this.verifyChat(data)) {
        this.setState({
          messages: [...this.state.messages, data]
        });

        // se o destinatário estiver com a conversa aberta, marca a mensagem como lida
        if (data.id_to === this.props.auth.user._id) {
          this.props.updateMessage(data._id);
        }

        //scrolla a tela para baixo
        setTimeout(() => {
          const objDiv = document.getElementById("chat-box");
          objDiv.scrollTop = objDiv.scrollHeight;
        }, 0);
      }
    });

    // quando a mensagem é lida
    socket.on("message readed", () => {
      this.setState({
        messages: this.state.messages.map(message => ({
          ...message,
          readedAt: new Date()
        }))
      });
    });

    socket.on("connected on the room", () => {
      this.setState({
        messages: this.state.messages.map(message => ({
          ...message,
          readedAt: new Date()
        }))
      });
    });

    socket.on("user typing", target => {
      this.setState({
        typing: true,
        typingTarget: target.id_to,
        typingFrom: target.id_from
      });
    });

    socket.on("user stop typing", target => {
      if (
        target.id_from === this.props.chat.id_to ||
        target.id_to === this.props.auth.user._id
      ) {
        this.setState({
          typing: false
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    //caso eu troque a janela do chat
    if (prevProps.chat.id_to !== this.props.chat.id_to) {
      // adiciona usuário na room
      socket.emit(
        "add user to chat room",
        `${this.props.chat.id_from}${this.props.chat.id_to}${
          this.props.chat.customer_key
        }`
      );

      // parou de digitar
      socket.emit("stop typing", {
        id_to: "",
        id_from: this.props.auth.user._id
      });
    }

    //verifica se as mensagens são diferentes
    if (prevProps.messages !== this.props.messages) {
      // atualiza mensagens
      this.setState({
        messages: this.props.messages
      });

      //scrolla a tela para baixo
      if (this.props.messagesParams.limit === 25) {
        setTimeout(() => {
          const objDiv = document.getElementById("chat-box");
          objDiv.scrollTop = objDiv.scrollHeight;
        }, 0);
      }
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    const { content } = this.state;
    const { id_from, id_to, customer_key } = this.props.chat;

    if (content.length > 0) {
      this.props.postMessages({
        id_from,
        id_to,
        customer_key,
        content
      });

      // parou de digitar
      socket.emit("stop typing", { id_to, id_from });

      setTimeout(() => {
        const objDiv = document.getElementById("chat-box");
        objDiv.scrollTop = objDiv.scrollHeight;
      }, 0);

      this.setState({
        content: ""
      });
    }
  };

  handleInputChange = e => {
    const { id_to, id_from } = this.props.chat;

    this.setState({
      [e.target.name]: e.target.value
    });

    if (e.target.value.length !== 0) {
      socket.emit("typing", { id_to, id_from });
    } else {
      socket.emit("stop typing", { id_to, id_from });
    }
  };

  insertEmoji = emoji => {
    this.setState({
      content: `${this.state.content} ${emoji}`
    });
    document.getElementById("input-text").focus();
  };

  verifyChat = data =>
    `${data.id_from}${data.id_to}${data.customer_key}` ===
      `${this.props.chat.id_from}${this.props.chat.id_to}${
        this.props.chat.customer_key
      }` ||
    `${data.id_from}${data.id_to}${data.customer_key}` ===
      `${this.props.chat.id_to}${this.props.chat.id_from}${
        this.props.chat.customer_key
      }`
      ? true
      : false;

  render() {
    return (
      <Container>
        <Head>
          <Avatar>
            {this.props.chat.user_avatar ? (
              <img
                src={this.props.chat.user_avatar}
                alt={`Avatar ${this.props.chat.user_name}`}
              />
            ) : (
              <img
                src={AvatarImg}
                alt={`Avatar ${this.props.chat.user_name}`}
              />
            )}
          </Avatar>
          <p>
            {this.props.chat.user_name}
            <small>
              {this.state.typing &&
              this.state.typingTarget === this.props.auth.user._id &&
              this.state.typingFrom === this.props.chat.id_to
                ? "Digitando..."
                : ""}
            </small>
          </p>
        </Head>
        {this.props.loading ? (
          <div className="load-container">
            <Loading />
          </div>
        ) : (
          <ul id="chat-box">
            {this.props.messagesParams.page * this.props.messagesParams.limit <
              this.props.messagesParams.total && (
              <li
                onClick={() => {
                  this.props.getMessages(
                    this.props.auth.user._id,
                    this.props.chat.id_to,
                    this.props.auth.user.customer.key,
                    this.props.messagesParams.limit + 25
                  );
                }}
                className="carregar-mais"
              >
                <span>Carregar mais</span>
              </li>
            )}
            {this.state.messages
              .sort((a, b) => {
                if (moment(a.createdAt) > moment(b.createdAt)) {
                  return 1;
                }

                if (moment(a.createdAt) < moment(b.createdAt)) {
                  return -1;
                }

                return 0;
              })
              .map((message, index) => (
                <li
                  className={
                    message.id_from === this.props.auth.user._id
                      ? "my-message"
                      : null
                  }
                  key={`${message._id}${index}`}
                >
                  <p className={message.readedAt ? "readed" : null}>
                    {message.content}{" "}
                    <i className="fas fa-check-double icon-read" />
                  </p>
                  <small>
                    {moment(message.createdAt).format("LT - DD/MM/YY ")}
                  </small>
                </li>
              ))}
          </ul>
        )}
        <form onSubmit={this.handleSubmit}>
          <div>
            <div className="emojis">
              <i className="fas fa-smile" />
              <div className="emojis-options">
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("😀")}
                >
                  😀
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("😃")}
                >
                  😃
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("😄")}
                >
                  😄
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("😅")}
                >
                  😅
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🙂")}
                >
                  🙂
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🤩")}
                >
                  🤩
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🤪")}
                >
                  🤪
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🤑")}
                >
                  🤑
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🤥")}
                >
                  🤥
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("😑")}
                >
                  😑
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🤔")}
                >
                  🤔
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("😂")}
                >
                  😂
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("😭")}
                >
                  😭
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🤣")}
                >
                  🤣
                </span>
                <span
                  role="img"
                  aria-label="emoji "
                  onClick={() => this.insertEmoji("😎")}
                >
                  😎
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("💪")}
                >
                  💪
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🙏")}
                >
                  🙏
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🙌")}
                >
                  🙌
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("👏")}
                >
                  👏
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🎂")}
                >
                  🎂
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🥳")}
                >
                  🥳
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🍰")}
                >
                  🍰
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🎈")}
                >
                  🎈
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🎉")}
                >
                  🎉
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🎁")}
                >
                  🎁
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("✔")}
                >
                  ✔
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🌞")}
                >
                  🌞
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🔥")}
                >
                  🔥
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("⌚")}
                >
                  ⌚
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("💎")}
                >
                  💎
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🔝")}
                >
                  🔝
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🔄")}
                >
                  🔄
                </span>
                <span
                  role="img"
                  aria-label="emoji"
                  onClick={() => this.insertEmoji("🔃")}
                >
                  🔃
                </span>
              </div>
            </div>
            <input
              name="content"
              type="text"
              placeholder="Digite sua mensagem"
              onChange={this.handleInputChange}
              value={this.state.content}
              id="input-text"
            />
            <button>
              <i className="fas fa-paper-plane" />
            </button>
          </div>
        </form>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  users: state.users.users,
  chat: state.chat,
  messages: state.messages.messages.docs,
  pendingMessages: state.messages.pendingMessages,
  loading: state.messages.loading,
  messagesParams: state.messages.messages
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...AuthActions,
      ...UsersActions,
      ...MessagesActions
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chat);



// WEBPACK FOOTER //
// ./src/components/ChatContainer/Chat/index.js